import { Vector } from '@ardoq/graph';
import { BlocksNode } from '../types';

export const getColPositions = (group: BlocksNode) => {
  const ret: number[] = [];

  ret.push(group.content![0]);
  group.colSize!.forEach(size => ret.push(ret[ret.length - 1] + size));

  return ret;
};

export const getRowPositions = (group: BlocksNode) => {
  const ret: number[] = [];

  ret.push(group.content![1]);
  group.rowSize!.forEach(size => ret.push(ret[ret.length - 1] + size));

  return ret;
};

export const getGridPosition = (
  gridNode: BlocksNode,
  index: Vector
): Vector => {
  const ret: Vector = [gridNode.content![0], gridNode.content![1]];
  const colSize = gridNode.colSize!;
  const rowSize = gridNode.rowSize!;

  for (let i = 0; i < index[0] && i < colSize.length; ++i) {
    ret[0] += colSize[i];
  }

  for (let i = 0; i < index[1] && i < rowSize.length; ++i) {
    ret[1] += rowSize[i];
  }

  return ret;
};

export const getRootNode = (node: BlocksNode) => {
  let u = node;

  while (u.parent) {
    u = u.parent;
  }

  return u;
};
